import type {RouteLocationNormalizedGeneric} from 'vue-router';
import useFeatures from '@/composables/useFeatures';
import {useServiceAccount} from '@/composables/useServiceAccount/useServiceAccount';
import {redirectToMeteor} from '@/router/redirectToMeteor';

export const resolveNotificationCenterRoute = (to: RouteLocationNormalizedGeneric): boolean => {
  const {isFeatureActive} = useFeatures();
  const {isNotificationCenterAccessible} = useServiceAccount();

  // The localStorage toggle stays in place as a fallback so current users keep access while iAm
  // rolls NOTIFICATION_CENTER out to accounts.
  if (isFeatureActive('page.settings.shop.emails') || isNotificationCenterAccessible.value) {
    return true;
  }

  return redirectToMeteor(to);
};
